import { useNavigate } from "react-router-dom";

import { getAuthToken } from "../../../lib/api/tokenStore";
import useCart from "../../cart/useCart";

const CartButton = () => {
  const navigate = useNavigate();
  const cart = useCart({ enabled: Boolean(getAuthToken()) });

  const count = cart.itemCount;

  return (
    <button
      type="button"
      className="sy-nav-cart"
      onClick={() => navigate("/my-cart")}
      aria-label={count ? `Cart, ${count} items` : "Cart"}
    >
      <img
        src="/assets/icons/header/cart.svg"
        alt=""
        width={24}
        height={24}
      />
      {count > 0 && (
        <span className="sy-nav-cart-badge">{count > 9 ? "9+" : count}</span>
      )}
    </button>
  );
};

export default CartButton;
